import React, { PropTypes } from 'react';
import Modal from 'modules/common/components/Modal';

export default class RefDetailModal extends React.Component {
  static propTypes = {
    line: PropTypes.object.isRequired,
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = this.parseLine(props.line);

    this.onModalClose = this.onModalClose.bind(this);
  }

  parseLine(line) {
    if (line.id) {
      return line;
    }
    return { label: line.label };
  }

  onModalClose() {
    this.setState({});
    this.props.onClose();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.line !== this.props.line) {
      this.setState({
        ...this.parseLine(nextProps.line),
      });
    }
  }

  onChange = (evt, _) => {
    this.setState({ label: evt.target.value, updated: true });
  };

  save = evt => {
    this.props.onSave(this.state);
  };

  render() {
    const { visible, line, onClose } = this.props;

    const buttonClass = 'ui approve primary button icon labeled';

    const title = line ? 'Modification' : 'Création';

    return (
      <Modal
        isOpened={visible}
        onOpen={this.initDropdown}
        onClose={onClose}
        closable
      >
        <div className="header" style={{ position: 'relative', zIndex: 1 }}>
          <div className="ui grid" style={{ overflow: 'initial' }}>
            <div className="row">
              <div className="two wide column middle aligned">{title}</div>
            </div>
          </div>
        </div>
        <div className="content ui form">
          <form>
            <div className="field">
              <label>Libellé</label>
              <input
                type="text"
                defaultValue={this.state.label}
                required
                className="ui field"
                maxLength="250"
                onChange={this.onChange}
              />
            </div>
          </form>
        </div>
        <div className="actions">
          <button className={buttonClass} onClick={this.save}>
            <i className="icon add" />Enregistrer
          </button>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/common/references/RefDetailModal.js